import { getClient } from './client';
import { parsePage } from './pageParsers';
import { getExcludeQuery, getIndustryQuery, getServicesQuery, getSolutionQuery, getTechnologyQuery } from './queries';
import { EntrySys, OrderFilterPaths } from 'contentful';

type GetCaseStudiesProps = {
    preview?: boolean;
    limit?: number;
    serviceId?: string | string[];
    solutionId?: string | string[];
    technologyId?: string | string[];
    industryId?: string | string[];
    excludeId?: string | string[];
    order?: [OrderFilterPaths<EntrySys, 'sys'>] | string[];
};

export const getCaseStudies = async (props: GetCaseStudiesProps) => {
    const {
        preview = false,
        limit = 100,
        serviceId,
        solutionId,
        technologyId,
        industryId,
        excludeId,
        order = ['-fields.publishDate'],
    } = props;

    const { items: pages } = await getClient(preview).withoutUnresolvableLinks.getEntries({
        limit,
        include: 10,
        content_type: 'pageCaseStudy',
        ...(serviceId && getServicesQuery(serviceId)),
        ...(solutionId && getSolutionQuery(solutionId)),
        ...(technologyId && getTechnologyQuery(technologyId)),
        ...(industryId && getIndustryQuery(industryId)),
        ...(excludeId && getExcludeQuery(excludeId)),
        order: order as any, // Contentful SDK doesn't support fields.* in types, but API does
    });

    return pages ? pages.map((page) => parsePage(page)) : [];
};
